function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M48.54,79.356c0,0-1.15,3.427-8.086,4.166c-6.936,0.74-9.895-0.739-9.895-0.739s4.624-3.605,9.063-3.791  C44.061,78.807,48.54,79.356,48.54,79.356z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M48.54,79.356c0,0,0.522-3.585-5.222-7.542c-5.745-3.956-9.052-4.066-9.052-4.066s1.898,4.885,6.521,7.745  C44.565,77.83,48.54,79.356,48.54,79.356z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.315,76.818c0,0-3.537-1.596-8.878-1.596s-9.363,2.775-9.363,2.775s3.953,1.594,9.641,1.594  C37.402,79.592,40.315,76.818,40.315,76.818z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M33.777,73.42c0,0-0.287-3.87-2.836-8.562c-2.549-4.694-6.907-6.904-6.907-6.904s0.485,4.235,3.2,9.233  C29.949,72.184,33.777,73.42,33.777,73.42z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M31.11,72.937c0,0-3.065-2.38-8.257-3.63c-5.192-1.251-9.752,0.504-9.752,0.504s3.47,2.478,9,3.81  C27.629,74.952,31.11,72.937,31.11,72.937z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.514,68.811c0,0-1.908-3.378-6.214-6.538c-4.306-3.16-9.189-3.304-9.189-3.304s2.244,3.625,6.828,6.991  C22.524,69.325,26.514,68.811,26.514,68.811z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.951,61.863c0,0,1.292-3.459,0.954-8.528c-0.337-5.07-3.224-8.714-3.224-8.714s-1.266,3.854-0.907,9.254  C19.134,59.272,21.951,61.863,21.951,61.863z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.328,58.586c0,0-1.328-3.078-4.735-6.188c-3.408-3.111-7.59-3.684-7.59-3.684s1.593,3.321,5.222,6.633  C14.853,58.659,18.328,58.586,18.328,58.586z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.273,51.764c0,0-0.164-3.349-2.264-7.457c-2.1-4.108-5.815-6.112-5.815-6.112s0.328,3.668,2.564,8.043  C12.994,50.614,16.273,51.764,16.273,51.764z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.839,41.772c0,0,0.288-3.34-1.24-7.693c-1.529-4.354-4.94-6.839-4.94-6.839s-0.169,3.679,1.458,8.314  C11.744,40.192,14.839,41.772,14.839,41.772z"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.223,35.188c0,0,1.533-2.981,1.77-7.589c0.237-4.608-1.978-8.201-1.978-8.201s-1.552,3.339-1.805,8.246  C13.957,32.552,16.223,35.188,16.223,35.188z"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.001,27.265c0,0,1.997-2.692,2.98-7.2c0.982-4.508-0.619-8.414-0.619-8.414s-2.075,3.043-3.121,7.844  C18.195,24.296,20.001,27.265,20.001,27.265z"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.448,47.467c0,0,2.497-2.236,4.363-6.456s1.081-8.368,1.081-8.368s-2.643,2.566-4.63,7.059  C15.274,44.196,16.448,47.467,16.448,47.467z"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.208,32.384c0,0,3.191-1.027,6.614-4.121c3.422-3.094,4.393-7.202,4.393-7.202s-3.458,1.268-7.102,4.563  C19.467,28.919,19.208,32.384,19.208,32.384z"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.923,23.153c0,0,3.02-1.458,5.983-4.992c2.964-3.536,3.36-7.739,3.36-7.739s-3.25,1.731-6.407,5.497  C23.704,19.684,23.923,23.153,23.923,23.153z"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M49.02,81.525c0,4.641-7.635,9.691-7.635,7.225S49.02,83.17,49.02,81.525z"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M53.443,81.525c0,4.641,7.635,9.691,7.635,7.225S53.443,83.17,53.443,81.525z"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M53.923,79.356c0,0,1.15,3.427,8.086,4.166c6.936,0.74,9.895-0.739,9.895-0.739s-4.624-3.605-9.063-3.791  C58.402,78.807,53.923,79.356,53.923,79.356z"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M53.923,79.356c0,0-0.522-3.585,5.222-7.542c5.745-3.956,9.052-4.066,9.052-4.066s-1.897,4.885-6.521,7.745  C57.897,77.83,53.923,79.356,53.923,79.356z"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M62.147,76.818c0,0,3.538-1.596,8.877-1.596c5.342,0,9.365,2.775,9.365,2.775s-3.954,1.594-9.642,1.594  C65.06,79.592,62.147,76.818,62.147,76.818z"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M68.686,73.42c0,0,0.287-3.87,2.835-8.562c2.549-4.694,6.907-6.904,6.907-6.904s-0.485,4.235-3.198,9.233  C72.514,72.184,68.686,73.42,68.686,73.42z"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M71.353,72.937c0,0,3.064-2.38,8.257-3.63c5.192-1.251,9.752,0.504,9.752,0.504s-3.47,2.478-8.999,3.81  C74.834,74.952,71.353,72.937,71.353,72.937z"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M75.948,68.811c0,0,1.909-3.378,6.214-6.538c4.307-3.16,9.19-3.304,9.19-3.304s-2.243,3.625-6.828,6.991  C79.939,69.325,75.948,68.811,75.948,68.811z"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M80.512,61.863c0,0-1.292-3.459-0.955-8.528c0.338-5.07,3.225-8.714,3.225-8.714s1.266,3.854,0.906,9.254  C83.329,59.272,80.512,61.863,80.512,61.863z"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M84.135,58.586c0,0,1.328-3.078,4.735-6.188c3.408-3.111,7.591-3.684,7.591-3.684s-1.595,3.321-5.223,6.633  C87.609,58.659,84.135,58.586,84.135,58.586z"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M86.188,51.764c0,0,0.163-3.349,2.264-7.457c2.101-4.108,5.815-6.112,5.815-6.112s-0.327,3.668-2.563,8.043  C89.468,50.614,86.188,51.764,86.188,51.764z"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  d: "M87.624,41.772c0,0-0.289-3.34,1.239-7.693c1.528-4.354,4.94-6.839,4.94-6.839s0.17,3.679-1.459,8.314  C90.718,40.192,87.624,41.772,87.624,41.772z"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M86.24,35.188c0,0-1.533-2.981-1.771-7.589c-0.236-4.608,1.978-8.201,1.978-8.201s1.553,3.339,1.806,8.246  C88.505,32.552,86.24,35.188,86.24,35.188z"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  d: "M82.461,27.265c0,0-1.997-2.692-2.979-7.2C78.5,15.557,80.1,11.651,80.1,11.651s2.074,3.043,3.121,7.844  C84.269,24.296,82.461,27.265,82.461,27.265z"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  d: "M86.016,47.467c0,0-2.499-2.236-4.365-6.456s-1.081-8.368-1.081-8.368s2.643,2.566,4.631,7.059  C87.188,44.196,86.016,47.467,86.016,47.467z"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  d: "M83.255,32.384c0,0-3.191-1.027-6.613-4.121c-3.424-3.094-4.394-7.202-4.394-7.202s3.457,1.268,7.103,4.563  C82.995,28.919,83.255,32.384,83.255,32.384z"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  d: "M78.538,23.153c0,0-3.019-1.458-5.982-4.992c-2.964-3.536-3.361-7.739-3.361-7.739s3.252,1.731,6.408,5.497  C78.759,19.684,78.538,23.153,78.538,23.153z"
});

var SvgWreath = function SvgWreath(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 200,
    height: 200,
    fill: "#000000",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWreath, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wreath.19e0b2e2.svg";
export { ForwardRef as ReactComponent };